import { ReactElement } from 'react'
import { useMappingSources } from 'app/components/mapping-sources/useMappingSources'
import {
  MappingSourcesShadcnComponent,
  getMappingSourcesShadcnColumns,
} from 'app/components/mapping-sources/MappingSourcesShadcnComponent'

export default function Sources(): ReactElement {
  const { sources, loading, canEditMapping, onAdd, onEdit, onDelete } =
    useMappingSources(getMappingSourcesShadcnColumns)

  return (
    <MappingSourcesShadcnComponent
      sources={sources}
      loading={loading}
      canEditMapping={canEditMapping}
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  )
}
